import { Stack } from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

export default function CardInterior({ item, children }) {
  const fileName_label = FindLangKey(
    'general-public-label-file-name'
  );
  const fileDescription_label = FindLangKey(
    'general-public-label-file-description'
  );
  return (
    <>
      <Stack
        gap=".5em"
        sx={{
          bgcolor: 'white',
          borderRadius: '20px',
          p: '.5em',
        }}
      >
        <Stack
          direction="row-reverse"
          justifyContent="space-between"
        >
          <p>{fileName_label}</p>
          <p>{ArabicToPersian(item?.NameFile)}</p>
        </Stack>
        <Stack
          direction="row-reverse"
          justifyContent="space-between"
        >
          <p>{fileDescription_label}</p>
          <p>{ArabicToPersian(item?.Description)}</p>
        </Stack>
        {children}
      </Stack>
    </>
  );
}
